// extracted by mini-css-extract-plugin
export default {"percentInput":"PercentInput_percentInput__CmqRS"};